import {Bar} from 'react-chartjs-2'
import {Chart, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title} from 'chart.js';

import {Row, Col} from 'react-bootstrap'
Chart.register( ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);

export default function RankingClientesChart({ranking}) {

    function generarNuevoColor () {
        var simbolos, color;
        simbolos = "0123456789ABCDEF";
        color = "#";
        for(var i = 0; i < 6; i++){
            color = color + simbolos[Math.floor(Math.random() * 16)];
        }
        return color
    }
    const dataVentas = {
        labels: ranking.map(v=> {
            return v.cliente
        }),
        datasets : [{
            label : "Ventas por Cliente",
            data : ranking.map(v=> {return v.ventas}),
            backgroundColor: ranking.map((elem) => elem.color ? elem.color : generarNuevoColor()),
            barThickness:20
        }]
    }
    const totalVentas = ranking.reduce((total, venta) => total + parseFloat(venta.ventas), 0);
    const opcionesVentas = {
        responsive : true,
        indexAxis: 'y',
        scales: {
            y: {
                barPercentage: 1,
                categoryPercentage: 1,
                ticks: {
                    autoSkip: false, // Evitar que salte etiquetas
                    font: {
                        size: 10, // Tamaño de fuente ajustable
                    },
                },
            },
            x: {
                beginAtZero: true,
            },
        },
        plugins: {
            legend: {
              position: 'right',
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const valor = tooltipItem.raw;
                        const porcentaje = ((valor / totalVentas) * 100).toFixed(2); // Calcula el porcentaje
                        return `${valor} (${porcentaje}%)`;
                    },
                },
            },
            title : {
                display : false,
                text: "Ranking de Clientes"
            }
        },
        maintainAspectRatio : false
    }
    const isMobile = window.innerWidth < 768;
    const dynamicHeight = `${ranking.length * 50}px`;
    console.log(dynamicHeight)
    
  return (
    <div style={{ width: '100%', height: dynamicHeight }}>
        <Bar data={dataVentas} options={opcionesVentas} />
    </div>
  )
}